import apiClient from '../apiClient';

const API_URL = '/art/aseguradoras';

// Obtener todas las aseguradoras (opcionalmente filtrar por activo)
export const getAseguradoras = async (activo = null) => {
    const params = {};
    if (activo !== null) params.activo = activo;

    const response = await apiClient.get(API_URL, { params });
    return response.data;
};

// Obtener aseguradora por ID
export const getAseguradoraPorId = async (id) => {
    const response = await apiClient.get(`${API_URL}/${id}`);
    return response.data;
};

// Crear aseguradora
export const crearAseguradora = async (data) => {
    const response = await apiClient.post(API_URL, data);
    return response.data;
};

// Actualizar aseguradora
export const actualizarAseguradora = async (id, data) => {
    const response = await apiClient.put(`${API_URL}/${id}`, data);
    return response.data;
};

// Eliminar aseguradora
export const eliminarAseguradora = async (id) => {
    const response = await apiClient.delete(`${API_URL}/${id}`);
    return response.data;
};

// Inactivar aseguradora (baja lógica)
export const inactivarAseguradora = async (id) => {
    const response = await apiClient.patch(`${API_URL}/${id}/inactivar`);
    return response.data;
};

// Reactivar aseguradora
export const reactivarAseguradora = async (id) => {
    const response = await apiClient.patch(`${API_URL}/${id}/reactivar`);
    return response.data;
};

